<template>
  <div>
    <template-chart :items="myItems" :yyyy="yyyy" :total="true"></template-chart>
  </div>
</template>

<script>
export default {
  props: ['item', 'yyyy', 'mm', 'value', 'group', 'prev', 'plan'],
  computed: {
    headers () {
      var temp = []
      temp.push({ title: '問合せ', key: 1, align: 'start', calc: 'ave' })
      temp.push({ title: '保護者面談', key: 2, align: 'end', calc: 'ave' })
      temp.push({ title: '体験授業', key: 3, align: 'end', calc: 'ave' })
      temp.push({ title: '提案', key: 4, align: 'end', calc: 'ave' })
      temp.push({ title: '入会', key: 5, align: 'end', calc: 'ave' })
      return temp
    },
    myItems () {
      var temp = []
      var acts = []
      for (var i in this.headers) {
        var values = this.item['calc_status'][this.yyyy][this.group].map(v => {
          return v[this.headers[i].key]
        })
        acts.push({
          'key': this.headers[i].key,
          'title': this.headers[i].title,
          'align': 'start',
          'values': values,
          'sum': (this.item['calc_status_sum'][this.yyyy][this.group][2][this.headers[i].key]).toFixed(1),
          'total': (this.item['calc_status_sum'][this.yyyy][this.group][0][this.headers[i].key]),
          'prefix': '',
          'suffix': '',
          'color': '#F8BBD080',
          'calc': 'ave'
        })
      }
      var prevs = []
      if (this.prev) {
        var prev = this.yyyy - 1
        var id = this.value ? 'calc_status_diff' : 'calc_status'
        if (prev >= 2018) {
          for (i in acts) {
            values = this.item[id][prev][this.group].map((v) => {
              return v[acts[i].key]
            })

            prevs.push({
              'key': 'prev' + acts[i].key,
              'title': this.value ? '昨年' : '昨年',
              'align': 'end',
              'values': values,
              'sum': (this.item[id + '_sum'][prev][this.group][2][this.headers[i].key]).toFixed(1),
              'total': this.value ? (this.item[id + '_sum'][prev][this.group][3][this.headers[i].key]) : (this.item[id + '_sum'][prev][this.group][0][this.headers[i].key]),
              'prefix': '',
              'suffix': this.value ? '%' : '',
              'color': '',
              'calc': ''
            })
          }
        }
      }
      // var plans = []
      // if (this.plan) {
      //   id = this.value ? 'calc_status_plans_diff' : 'calc_plans_status'
      //   for (i in acts) {
      //     values = this.item[id][this.yyyy][this.group].map((v) => {
      //       return v[acts[i].key]
      //     })

      //     plans.push({
      //       'key': 'plans' + acts[i].key,
      //       'title': this.value ? '目標' : '目標',
      //       'align': 'end',
      //       'values': values,
      //       'sum': this.item[id + '_sum'][this.yyyy][this.group][2][this.headers[i].key],
      //       'total': this.value ? (this.item[id + '_sum'][this.yyyy][this.group][3][this.headers[i].key]) : (this.item[id + '_sum'][this.yyyy][this.group][0][this.headers[i].key]),
      //       'prefix': '',
      //       'suffix': this.value ? '%' : '',
      //       'color': '',
      //       'calc': ''
      //     })
      //   }
      // }
      for (i in acts) {
        temp.push(acts[i])
        if (prevs.length !== 0) {
          temp.push(prevs[i])
        }
        // if (plans.length !== 0) {
        //   temp.push(plans[i])
        // }
      }
      return temp
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
